module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-MATCH.6b1f44ea.png";